import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { testimonials } from '../data/testimonials';
import { motion } from 'framer-motion';

const Testimonials = () => {
  return (
    <section className="py-24 px-6 bg-slate-950 relative overflow-hidden">
      {/* Background Decor */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full pointer-events-none opacity-20">
        <div className="absolute top-0 left-0 w-96 h-96 bg-amber-500/10 rounded-full blur-[100px]"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6">
            Trusted by <span className="text-amber-500">Action-Takers</span>
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            Real stories from coaches, consultants, and founders who stopped "learning" and started "installing."
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((item, i) => (
            <motion.div 
              key={item.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-slate-900/50 border border-slate-800 p-8 rounded-3xl hover:border-amber-500/30 transition-all group"
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(item.rating)].map((_, i) => (
                  <SafeIcon key={i} icon={FiIcons.FiStar} className="text-amber-500 fill-amber-500 text-sm" />
                ))}
              </div>

              <p className="text-slate-300 italic mb-8 leading-relaxed">
                "{item.text}"
              </p>

              <div className="flex items-center gap-4 border-t border-slate-800 pt-6">
                <img 
                  src={item.image} 
                  alt={item.name} 
                  className="w-12 h-12 rounded-full object-cover grayscale group-hover:grayscale-0 transition-all"
                />
                <div>
                  <h4 className="text-white font-bold">{item.name}</h4>
                  <p className="text-amber-500 text-xs font-bold uppercase tracking-widest">{item.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-4 bg-slate-900 px-6 py-3 rounded-full border border-slate-800">
             <div className="flex -space-x-2">
               {testimonials.slice(0, 3).map((t) => (
                 <img key={t.id} src={t.image} className="w-8 h-8 rounded-full border-2 border-slate-900 object-cover" />
               ))}
             </div>
             <p className="text-sm text-slate-400">
               Join <span className="text-white font-bold">500+</span> Entrepreneurs inside Diamond 2.0
             </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;